import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: "/re/sectors", params });
